module.exports = __webpack_public_path__ + "media/videos.a8b95cba.mp4";